/* eslint-disable @typescript-eslint/no-explicit-any */
import { memo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Dialog as MuiDialog } from '@mui/material';
import { dialogSelector, closeDialog } from 'store/dialog/dialogSlice';

function Dialog() {
  const dispatch = useDispatch();
  const dialogState = useSelector(dialogSelector);
  const { open, content, fullScreen, disableBackdropClick, disableEscapeKeyDown, onClose } = dialogState;
  const DialogStyle = {
    '& .MuiDialog-paper': {
      borderRadius: fullScreen ? 0 : '10px',
      margin: '0 !important',
      maxWidth: 900,
      border: `1px solid #707070`,
    },
  };

  const handleCloseDialog = (_event: any, reason: string) => {
    if (!disableBackdropClick || !['backdropClick', 'escapeKeyDown'].includes(reason) || !disableEscapeKeyDown) {
      dispatch(closeDialog());
      if (onClose) {
        try {
          onClose();
        } catch (e) {
          //
        }
      }
    }
  };

  return (
    <MuiDialog open={Boolean(open && content)} sx={DialogStyle} fullScreen={fullScreen} onClose={handleCloseDialog}>
      {content}
    </MuiDialog>
  );
}

export default memo(Dialog);
